import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const AdvancePayment = () => {
  return (
    <Box sx={{ mt: 2, p: 2 }}>
      <Card>
        <CardContent>
          <Typography variant="h6" align="center">
            Advance Payment
          </Typography>
          <Typography align="center" color="textSecondary">
            🚧 This section is under construction 🚧
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default AdvancePayment;
